export const EMAIL_OTP_REQUEST_MINUTES = 3;

export const LOGIN_TYPE = {
    learner: 'Learner',
    administrator: 'Administrator'
};

export const TABLE_CONST = {
    DEFAULT_PER_PAGE: 10
};

export const quizCategoryColors = {
    learning: '#efd66f',
    reading: '#ed6dad',
    writing: '#4ea9cb',
    oralcommunication: '#a469d1',
    numeracy: '#19a65b'
};

export const deploymentTags = [
    'Overdue',
    'Quiz Off',
    'Deactivated',
    'API',
    'Course Ready',
    'Budget',
    'Standard',
    'Unlimited',
    'TAFE/College',
    'Custom'
];

export const paginationValues = [5, 10, 25, 50, 100, 200];
export const SUPPORT_EMAIL = {
    default: 'support',
    domain: process.env.REACT_APP_SUPPORT_EMAIL_DOMAIN || 'tlrg.com.au'
};
export const ROLES = ['Administrator', 'Analyst', 'Intake Assistant', 'Enrolment Officer'];

export const TRIAL_REQUEST_TAGS = ['Active', 'Approved', 'Declined'];

export const TRIGGER_WORD_PACKAGES = ['Generic', 'RII', 'TLI', 'HLT', 'CHC', 'SIT', 'CPC', 'MSA', 'BSB', 'FNS', 'SIR', 'ICT', 'CPP'];

export const SKILLS = ['learning', 'reading', 'writing', 'oralcommunication', 'numeracy'];

export const DEPLOYMENT_REQUEST_TAGS = ['Active', 'Declined'];

export const DEFAULT_LOGO_URL = 'https://s3.ap-southeast-2.amazonaws.com/static.lln.training/clients/tlrg-online/client-logo.png';

export const TEST_LEVEL_LABEL = {
    acsf3: 'ACSF3',
    acsf4: 'ACSF4',
    vfh: 'VSL',
    acsf3shortcourse: 'ACSF3 Short Course',
    dlrq: 'Course Ready'
};

export const FORM_GRID_SPACING = 2;

export const IMG_LOGO_SIZE = {
    xs: {
        width: 400,
        height: 200
    },
    sm: {
        width: 470,
        height: 230
    },
    md: {
        width: 650,
        height: 250
    },
    lg: {
        width: 680,
        height: 280
    },
    xl: {
        width: 700,
        height: 300
    }
};

export const DEFAULT_EMAIL_TEMPLATES = [
    {
        templateKey: 'lln-client-subscription-near-expiry',
        label: 'Client Subscription Near Expiry',
        sender: 'admin@lln.training',
        subject:
            'LLN Robot Deployment ID:<variable>deploymentId</variable> Subscription <variable>subscriptionName</variable> Expiry Reminder – <variable>subscriptionDaysRemaining</variable> Day(s) Remaining',
        body: '<p>Hello&nbsp;<strong><variable>contactName</variable></strong>,</p><p><br></p><p>This is a reminder that the subscription for&nbsp;<strong><variable>deploymentDisplayName</variable></strong>&nbsp;is scheduled to expire on&nbsp;<strong><variable>subscriptionExpiryDate</variable></strong>.</p><p><br></p><p>There are currently&nbsp;<strong><variable>subscriptionDaysRemaining</variable></strong>&nbsp;day(s) remaining before the subscription expires.</p><p><br></p><p>To ensure uninterrupted access to the platform and services, please review and renew the subscription before the expiry date.</p><p><br></p><h3>What do I need to do?</h3><p>To renew your subscription, please contact our Sales Team, who will be happy to assist you with the renewal process and answer any questions you may have.</p><p><br></p><h3><strong>Sales Contact Details</strong></h3><p><span style="color: inherit;">Email: sales@trlg.com.au</span></p><p><br></p><h3><strong>Subscription Details</strong></h3><p>Client Name:&nbsp;<strong><variable>deploymentDisplayName</variable></strong></p><p>Expiry Date:&nbsp;<strong><variable>subscriptionExpiryDate</variable></strong></p><p>Remaining Days:&nbsp;<strong><variable>subscriptionDaysRemaining</variable></strong></p><p><br></p><p>If you have already renewed your subscription or are currently discussing your renewal with our team, please disregard this reminder.</p>',
        footer: '<p><p>Kind regards,</p><br/><p><strong>Matt Peachey</strong></p><p>Managing Director</p><p>The Learning Resources Group</p></p>'
    }
];

export const EMAIL_TEMPLATE_VARIABLES = [
    {
        id: 'deploymentId',
        label: 'Deployment Id',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['lln-client-subscription-near-expiry']
    },
    {
        id: 'subscriptionName',
        label: 'Subscription Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['lln-client-subscription-near-expiry']
    },
    {
        id: 'subscriptionDaysRemaining',
        label: 'Subscription Days Remaining',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['lln-client-subscription-near-expiry']
    },
    {
        id: 'contactName',
        label: 'Contact Name',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['lln-client-subscription-near-expiry']
    },
    {
        id: 'deploymentDisplayName',
        label: 'Deployment Display Name',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['lln-client-subscription-near-expiry']
    },
    {
        id: 'subscriptionExpiryDate',
        label: 'Subscription Expiry Date',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['lln-client-subscription-near-expiry']
    }
];
